import React from 'react';
import { useNavigate } from 'react-router-dom';
import { InvoiceItem } from '../customerDashboardTypes';
import styles from './OutstandingInvoices.module.css';

interface OutstandingInvoicesProps {
  invoices: InvoiceItem[];
}

export const OutstandingInvoices: React.FC<OutstandingInvoicesProps> = ({ invoices }) => {
  const navigate = useNavigate();
  return (
    <div className={styles.container}>
      <h3 className={styles.title}>Outstanding Invoices</h3>
      <div className={styles.list}>
        {invoices.map((invoice) => (
          <div key={invoice.id} className={styles.item}>
            <div className={styles.info}>
              <span className={styles.invoiceNumber}>{invoice.invoiceNumber}</span>
              <span className={styles.dueDate}>{invoice.dueDate}</span>
            </div>
            <div className={styles.right}>
              <span className={styles.amount}>{invoice.amount}</span>
              <button
                type="button"
                className={styles.payBtn}
                onClick={() => navigate('/customer-invoices')}
              >
                Pay Now
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
